import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MutualModule } from '../mutual/mutual.module';
import {
  AddressBaseUpdateComponent,
  AddressDetailsComponent,
  AddressLinesComponent,
  AddressUpdateComponent,
  AddressViewCompanyComponent,
  AddressViewIsfComponent,
  CountryDropdownComponent,
  StateDropdownComponent,
} from './components';

@NgModule({
  imports: [CommonModule, MutualModule],
  declarations: [
    AddressBaseUpdateComponent,
    AddressUpdateComponent,
    StateDropdownComponent,
    AddressViewIsfComponent,
    AddressDetailsComponent,
    CountryDropdownComponent,
    AddressViewCompanyComponent,
    AddressLinesComponent,
  ],
  exports: [
    AddressLinesComponent,
    AddressUpdateComponent,
    AddressDetailsComponent,
    CountryDropdownComponent,
    AddressBaseUpdateComponent,
    StateDropdownComponent,
  ],
})
export class AddressModule {}
